import React, { useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { CSVLink } from 'react-csv';
import { ExportButton } from './ExportBtn.styled';
import { toast } from '../../../../../redux/actions/UI';

const ExportBtn = ({ tableRowData, message }) => {
  const dispatch = useDispatch();
  const [csvData, setCsvData] = useState('');
  const csvInstance = useRef(null);

  useEffect(() => {
    if (
      csvData &&
      csvInstance &&
      csvInstance.current &&
      csvInstance.current.link
    ) {
      setTimeout(() => {
        csvInstance.current.link.click();
        setCsvData('');
      });
    }
  }, [csvData]);

  const formatCSVExport = deliveryTableData => {
    const exportData = [];

    for (const contactDeliveryData of deliveryTableData) {
      const newCSVRow = {
        'Full Name': contactDeliveryData.fullName,
        'M1 ID': contactDeliveryData.m1_id,
        'Member ID': contactDeliveryData.memberId,
        Email: contactDeliveryData.email,
        Phone: contactDeliveryData.phone,
        'Date/Time': contactDeliveryData.deliveryDate,
        'Message Subject': message.messageSubject,
        'Delivered Yes/No': contactDeliveryData.wasDelivered ? 'Yes' : 'No',
      };
      exportData.push(newCSVRow);
    }
    return exportData.sort(
      (a, b) =>
        new Date(b['Delivery Date/Time']) - new Date(a['Delivery Date/Time'])
    );
  };

  const handleExport = async () => {
    try {
      const exportData = formatCSVExport(tableRowData);
      setCsvData(exportData);
    } catch (e) {
      console.error(e);
      dispatch(toast('error', 'Failed to export delivery events data'));
    }
  };

  return (
    <>
      <ExportButton onClick={handleExport} disabled={!tableRowData.length}>
        Export
      </ExportButton>
      {csvData.length ? (
        <CSVLink
          data={csvData}
          filename={`Delivery Activity Report for ${message.messageSubject}.csv`.replaceAll(
            '/',
            '.'
          )}
          ref={csvInstance}
        />
      ) : undefined}
    </>
  );
};

export default ExportBtn;
